/** @format */

import React, { PureComponent } from 'react';
import Datetime from 'react-datetime';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import I18 from '../Translate/I18n';
import FormHelperText from '@material-ui/core/FormHelperText';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import Moment from 'moment';
import '../../assets/themes/OPL/css/react-date-time.css';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';

require('moment/locale/pl');

class DatePickerForm extends PureComponent {
    componentDidMount() {
        if (!this.props.defaultValue) {
            this.props.callback(new Moment());
        }
    }

    render() {
        const {
            classes,
            defaultValue,
            isValidDate,
            callback,
            helpText,
            error,
            success,
            id,
            dateFormat,
            fieldName,
            fullWidth,
            timeFormat,
            autoComplete,
        } = this.props;

        let { placeholder } = this.props;

        const helpTextClasses = classNames({
            [classes.labelRootError]: error,
            [classes.labelRootSuccess]: success && !error,
            [classes.labelRootPadding]: true,
            [classes.labelRootColor]: true,
        });

        const rdtClasses = classNames({
            [classes.label]: true,
            [classes.datePicker]: true,
        });

        let overrideDefaultValue;

        if (defaultValue) {
            overrideDefaultValue = defaultValue;
        } else {
            overrideDefaultValue = new Date();
        }

        if (!placeholder) {
            if (timeFormat === true) {
                placeholder = 'DD-MM-YYYY HH:MM';
            } else {
                placeholder = 'DD-MM-YYYY';
            }
        }

        return (
            <FormControl id={'reactDateTime'} className={rdtClasses} fullWidth={fullWidth || true}>
                {helpText !== undefined ? (
                    <FormHelperText id={id + '-text'} className={helpTextClasses}>
                        <I18 trans={helpText} />
                    </FormHelperText>
                ) : null}
                <Datetime
                    locale="pl"
                    {...this.props}
                    defaultValue={overrideDefaultValue}
                    isValidDate={isValidDate}
                    dateFormat={dateFormat ? dateFormat : 'DD-MM-YYYY'}
                    timeFormat={timeFormat}
                    onChange={(moment) => callback(moment)}
                    inputProps={{
                        id: fieldName,
                        placeholder: placeholder,
                        autoComplete: autoComplete,
                        className: classes.datePickerInput,
                    }}
                />
            </FormControl>
        );
    }
}

DatePickerForm.propTypes = {
    callback: PropTypes.func.isRequired,
    helpText: PropTypes.string,
    dateFormat: PropTypes.string,
    placeholder: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isValidDate: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    error: PropTypes.bool,
    success: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fieldName: PropTypes.string,
    fullWidth: PropTypes.bool,
    autoComplete: PropTypes.string,
    timeFormat: PropTypes.bool,
    open: PropTypes.bool,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    shouldSetInitialValue: PropTypes.bool,
};

export default withStyles(oplAppStyle)(DatePickerForm);
